import { render, staticRenderFns } from "./Conjuge.vue?vue&type=template&id=2a91fb65&scoped=true&"
import script from "./Conjuge.vue?vue&type=script&lang=js&"
export * from "./Conjuge.vue?vue&type=script&lang=js&"
import style0 from "./Conjuge.vue?vue&type=style&index=0&id=2a91fb65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91fb65",
  null
  
)

export default component.exports